var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDdh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.69202 5.39929V17.9993H12.2C13.568 17.9993 14.768 17.7353 15.8 17.2073C16.832 16.6793 17.636 15.9473 18.212 15.0113C18.788 14.0633 19.076 12.9593 19.076 11.6993C19.076 10.4273 18.788 9.32329 18.212 8.38729C17.636 7.45129 16.832 6.71929 15.8 6.19129C14.768 5.66329 13.568 5.39929 12.2 5.39929H6.69202ZM12.092 16.0193H9.03202V7.37929H12.092C13.04 7.37929 13.856 7.55929 14.54 7.91929C15.236 8.27929 15.77 8.78329 16.142 9.43129C16.526 10.0673 16.718 10.8233 16.718 11.6993C16.718 12.5633 16.526 13.3193 16.142 13.9673C15.77 14.6153 15.236 15.1193 14.54 15.4793C13.856 15.8393 13.04 16.0193 12.092 16.0193Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDdh);
export default __webpack_public_path__ + "static/media/icon-ddh.778b2a9ebcd912cae9a65203e39bbcbd.svg";
export { ForwardRef as ReactComponent };